import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { endpoints } from '@shared/endpoints';
import { TournamentsWithPagination } from '@shared/models/common.interface';
import { SmartTableResult } from '@shared/models/smart-table.interface';
import { shareReplay } from 'rxjs';
import {
    CreateProfileRequest,
    UpdateProfileRequest,
} from '../models/api/requests/user-management.request';
import {
    PlayerProfilesWithPagination,
    ProfileInfo,
    ProfileLogs,
} from '../models/api/response/user-management.response';

@Injectable({
    providedIn: 'root',
})
export class UserManagementService {
    constructor(private http: HttpClient) {}

    depositAccount({ profileId, ...requestData }: any) {
        return this.http.patch<any>(
            endpoints.admin.children.depositAccount(profileId),
            requestData
        );
    }

    sendBroadcastNotification(text: string) {
        return this.http
            .post(endpoints.admin.children.sendBroadcastNotificationToUsers(), {
                messageText: text,
            })
            .pipe(shareReplay());
    }
    unbanUser(profileId: string) {
        return this.http.put(endpoints.admin.children.unbanUser(profileId), {
            profileIds: [profileId],
        });
    }

    fetchPlayers(result?: SmartTableResult) {
        return this.http
            .get<PlayerProfilesWithPagination>(
                endpoints.admin.children.getPlayersUrl(result)
            )
            .pipe(shareReplay());
    }

    fetchProfileTournaments(profileId: string) {
        return this.http
            .get<TournamentsWithPagination>(
                endpoints.userProfile.children.getProfileTournamentsUrl(
                    profileId
                )
            )
            .pipe(shareReplay());
    }

    profileTurnOff2fa(userId: string) {
        return this.http
            .post<void>(
                endpoints.identity.children.getDisable2faUrl(userId),
                {}
            )
            .pipe(shareReplay());
    }

    fetchProfileInfo(profileId: string) {
        return this.http
            .get<ProfileInfo>(
                endpoints.admin.children.getProfileInfoUrl(profileId)
            )
            .pipe(shareReplay());
    }

    resetProfilePassword(userId: string) {
        return this.http.post<void>(
            endpoints.identity.children.getResetPasswordUrl(userId),
            {}
        );
    }

    createProfile(request: CreateProfileRequest) {
        return this.http.post<void>(
            endpoints.identity.children.getCreateUserUrl(),
            request
        );
    }

    updateProfile(profileId: string, request: UpdateProfileRequest) {
        return this.http.put<void>(
            endpoints.admin.children.getUpdateProfileUrl(profileId),
            request
        );
    }

    deleteProfile(profileId: string) {
        return this.http.delete<void>(
            endpoints.admin.children.getDeleteProfileUrl(profileId)
        );
    }

    fetchPlayerIpLogs(profileId: string) {
        return this.http.get<ProfileLogs[] | null>(
            endpoints.admin.children.getPlayerIpLogs(profileId)
        );
    }
}
